import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast, ToastContainer } from 'react-toastify'
import circle from '../../../../images/main/curcle.svg'
import vector_right from '../../../../images/basic/header/vector_right.svg'
import moscow from '../../../../images/main/moscow.png'
import volginsky from '../../../../images/main/volginsky-main.jpg'
import skolkovo from '../../../../images/main/skolkovo.jpg'
import alabyshevo from '../../../../images/main/alabyshevo.jpg'
import circle_green from '../../../../images/main/greenIcon.svg'

import styles from './styles.module.scss'
import { Link } from 'react-router-dom'

const OurLocation = () => {
  const _domenWork = 'career.generium.ru'
  const [activeCity, setActiveCity] = useState(0)
  const city = ['Москва', 'Вольгинский', 'Алабушево']
  // const [city, setСities] = useState([])
  // let checkDomenNameState = ''
  // let _protocol = window.location.protocol
  // const getAllCities = async () => {
  //   if (window.location.hostname.indexOf(_domenWork) != -1) {
  //     checkDomenNameState = window.location.hostname
  //   }
  //   try {
  //     const result = await axios({
  //       method: 'get',
  //       url: `${_protocol}//${checkDomenNameState}/api/v1/unit/cities`
  //     })
  //     setСities(result.data)
  //   } catch (e) {
  //     toast.error('Ошибка загрузки списка городов')
  //   }
  // }
  // useEffect(() => {
  //   getAllCities()
  // }, [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.wr1}>
        <div className={styles.left}>
          <div>
            <p className={styles.title}>Наши локации</p>
          </div>
        </div>
        <div className={styles.right}>
          <div className='flex flex-col'>
            <p className={styles.title}>Карьера в разных локациях</p>
          </div>
        </div>
      </div>
    <div className={styles.wr2}>
      <div className={styles.left}>
        <div>
          <div className={styles.list_scroll_box}>
            <div className={styles.list_wrapper}>
              {city.map((item, index) => (
                <div className={styles.list} key={index}>
                  <svg
                    width='8'
                    height='8.5'
                    viewBox='0 0 8 9'
                    xmlns={activeCity === index ? circle_green : circle}
                    className={activeCity === index ? styles.circle_active : styles.circle}
                  >
                    <path d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z' />
                  </svg>
                  <p
                    onClick={() => setActiveCity(index)}
                    className={activeCity === index ? styles.title_name_active : styles.title_name}
                  >
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div>
          {activeCity === 1 ? (
            <div className={styles.down_side}>
              <p>
                Сотрудники Generium в Вольгинском отвечают за разработку и производство препаратов. Здесь же работают
                отделы контроля качества и логистики.
              </p>
              <Link className={styles.button} to='/relocation'>
                Узнать о жизни в поселке{' '}
                <img className={styles.vector_right} src={vector_right} alt='vector' draggable='false' />
              </Link>
            </div>
          ) : activeCity === 0 ? (
            <div className={styles.down_side}>
              <p>
                Сотрудники московского офиса отвечают за клинические и доклинические исследования, регистрацию
                лекарственных препаратов, запуск проектов и продажи. Здесь же работают сотрудники бэк-офиса.
              </p>
            </div>
          ) : (
            <div className={styles.down_side}>
              <p>
                Производственный комплекс полного цикла. Здесь сотрудники осуществляют складские операции, упаковку и
                транспортировку лекарственных препаратов.
              </p>
            </div>
          )}
        </div>
      </div>
      <div className={styles.right}>
        <div className='flex flex-col'>
          {/*activeCity !== 1  && */ (
            <div className={styles.rightSide_photoContainer}>
              <img
                draggable='false'
                src={activeCity === 0 ? moscow : activeCity === 1 ? volginsky : activeCity === 2 ? alabyshevo : moscow}
                alt='photo_city'
                className={styles.rightSide_photo}
              />
              <p className={styles.rightSide_photoLegal}>
                {activeCity === 2 ? "" : activeCity === 3 ? "": null}
              </p>
            </div>
          )}
          {/*
          {activeCity === 1 && (
            <div className={styles.rightSide_iframe}>
              <iframe
                src='https://www.youtube.com/embed/vOfU7eA4UcA?modestbranding=1&showinfo=0'
                title='YouTube video player'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              />
            </div>
          )}
          */}
          {activeCity === 1 ? (
            <div className={styles.down_side}>
              <p className={styles.text}>
                Сотрудники Generium в Вольгинском отвечают за разработку и производство препаратов. Здесь же работают
                отделы контроля качества и логистики.
              </p>
              <Link className={styles.button} to='/relocation'>
                Узнать о жизни в поселке <img className={styles.vector_right} src={vector_right} alt='vector' />
              </Link>
            </div>
          ) : activeCity === 0 ? (
            <div className={styles.down_side}>
              <p className={styles.text}>
                Сотрудники московского офиса отвечают за клинические и доклинические исследования, регистрацию
                лекарственных препаратов, запуск проектов и продажи. Здесь же работают сотрудники бэк-офиса.
              </p>
            </div>
          ) : (
            <div className={styles.down_side}>
              <p className={styles.text}>
                Производственный комплекс полного цикла. Здесь сотрудники осуществляют складские операции, упаковку и
                транспортировку лекарственных препаратов.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
</div>
  )
}

export default OurLocation
